window.onload = function () {
  const navigation = document.querySelector('.module-onepage-navigation');
  const body = document.querySelector('body');
  const menu_button = document.querySelector('.mobile-navigation-trigger');

  function handleResize() {
    menu_button.setAttribute('data-state', 'closed');
    menu_button.setAttribute('aria-expanded', 'false');
    navigation.setAttribute('aria-expanded', 'false');
    body.classList.remove('fixed');
  }

  if (navigation && menu_button) {
    menu_button.addEventListener('click', () => {
      const currentState = menu_button.getAttribute('data-state');

      if (!currentState || currentState === 'closed') {
        // Deactivate the resize listener to prevent conflicts with show/hide browser bars
        window.removeEventListener('resize', handleResize);

        menu_button.setAttribute('data-state', 'opened');
        menu_button.setAttribute('aria-expanded', 'true');
        navigation.setAttribute('aria-expanded', 'true');
        body.classList.add('fixed');

        // Activate the resize listener again after a short delay
        setTimeout(function () {
          window.addEventListener('resize', handleResize);
        }, 500);

      } else {
        menu_button.setAttribute('data-state', 'closed');
        menu_button.setAttribute('aria-expanded', 'false');
        navigation.setAttribute('aria-expanded', 'false');
        body.classList.remove('fixed');
      }
    });

    window.addEventListener('resize', handleResize);

    const links = navigation.querySelectorAll('a[data-onepage-link]');
    if (links && links.length) {
      links.forEach(link => {
        link.addEventListener('click', (event) => {
          menu_button.setAttribute('data-state', 'closed');
          menu_button.setAttribute('aria-expanded', 'false');
          navigation.setAttribute('aria-expanded', 'false');
          body.classList.remove('fixed');
        });
      });
    }
  }
};
